import { render } from "./MentionTextarea.vue?vue&type=template&id=a0548464&scoped=true"
import script from "./MentionTextarea.vue?vue&type=script&lang=js"
export * from "./MentionTextarea.vue?vue&type=script&lang=js"

import "./MentionTextarea.vue?vue&type=style&index=0&id=a0548464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0548464"]])

export default __exports__